import { useInsertLead } from '@/hooks/useInsertLead';
import { newsletterSignUpSchema } from '@/schema/newsletterSignUpSchema';
import { NewsletterSignUpType } from '@/types';

import { ArrowRight } from '@prenuvo/halo-icon';
import { Icon, InputField, Typography } from '@prenuvo/halo-web';
import { useState } from 'react';

const defaultNewsletterSignUp = {
  email: '',
  firstname: '',
  lastname: '',
};

const NewsletterSignUp = () => {
  const [newsletterSignUp, setNewsletterSignUp] =
    useState<NewsletterSignUpType>(defaultNewsletterSignUp);
  const [errorsInNewsletterSignUp, setErrorsInNewsletterSignup] =
    useState<NewsletterSignUpType>(defaultNewsletterSignUp);

  const { trigger: triggerInsertLead } = useInsertLead({ newsletterSignUp });
  const handleChange = (field: string, value: any) => {
    setNewsletterSignUp({ ...newsletterSignUp, [field]: value });
    setErrorsInNewsletterSignup({ ...errorsInNewsletterSignUp, [field]: '' });
  };

  const onSubmit = () => {
    setErrorsInNewsletterSignup(defaultNewsletterSignUp);
    const validationResult = newsletterSignUpSchema.safeParse(newsletterSignUp);
    if (validationResult.success === false) {
      const errors: NewsletterSignUpType = defaultNewsletterSignUp;
      Object.entries(
        validationResult.error.flatten()?.fieldErrors as [string, string[]][],
      )?.forEach((error) => {
        const [path, message] = error;
        errors[path as keyof NewsletterSignUpType] = message[0];
      });
      setErrorsInNewsletterSignup({ ...errorsInNewsletterSignUp, ...errors });
      return;
    }
    triggerInsertLead();
  };
  const checkKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onSubmit();
    }
  };

  return (
    <div className="order-first md:order-none">
      <Typography variant="label-xs" as="label" className="text-footerGray">
        Our insights straight to your inbox
      </Typography>
      <form onSubmit={onSubmit}>
        <div className="mt-4 grid grid-cols-2 gap-4">
          <InputField
            label={{
              children: 'First Name',
            }}
            size="md"
            type="text"
            variant="filled"
            name="firstname"
            onChange={(e) => handleChange('firstname', e.target.value)}
            isInvalid={!!errorsInNewsletterSignUp?.firstname}
            caption={{
              translationKey: errorsInNewsletterSignUp?.firstname,
            }}
            value={newsletterSignUp.firstname}
          />
          <InputField
            label={{
              children: 'Last Name',
            }}
            size="md"
            type="text"
            variant="filled"
            name="lastName"
            onChange={(e) => handleChange('lastname', e.target.value)}
            isInvalid={!!errorsInNewsletterSignUp?.lastname}
            caption={{
              translationKey: errorsInNewsletterSignUp?.lastname,
            }}
            value={newsletterSignUp.lastname}
          />
        </div>
        <InputField
          label={{
            children: 'Enter your email',
          }}
          size="md"
          type="email"
          variant="filled"
          name="email"
          endIcon={
            <Icon className="fill-current" size="md" source={ArrowRight} onClick={onSubmit} />
          }
          onChange={(e) => handleChange('email', e.target.value)}
          isInvalid={!!errorsInNewsletterSignUp?.email}
          caption={{
            translationKey: errorsInNewsletterSignUp?.email,
          }}
          value={newsletterSignUp.email}
          onKeyDown={checkKeyDown}
        />
      </form>
    </div>
  );
};

export default NewsletterSignUp;
